// The Question card's rules, with no UI attached (sculpt-api PLAN-questions.md). The card and the session
// both need them: the card to draw and send, the session to answer a card the user replied to by typing in
// the chat box instead of filling it in.
import type { AgentQuestion, QuestionAnswer, QuestionCardInput, ToolCard } from '../../types/agent';

/** The questions of a card, ignoring anything malformed: the pane never breaks on a card it cannot read. */
export function questionsOf(card: ToolCard): AgentQuestion[] {
  const input = card.input as Partial<QuestionCardInput> | undefined;
  const questions = input?.questions;
  if (!Array.isArray(questions)) return [];
  return questions.filter((q): q is AgentQuestion => !!q && typeof q.id === 'string' && typeof q.text === 'string');
}

/** What the card sends back: what the user gave, and for everything else the agent's own suggestion, marked
 *  as its own to decide. An untouched card is therefore a valid answer — agreeing is one click. */
export function answersFor(questions: AgentQuestion[], given: Record<string, string> = {}): QuestionAnswer[] {
  return questions.map((q) => {
    const value = (given[q.id] ?? '').trim();
    return value ? { id: q.id, answer: value, left_to_sculpt: false } : { id: q.id, answer: q.suggestion ?? '', left_to_sculpt: true };
  });
}
